import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { FaLinkedin } from "react-icons/fa";
import { TbWorld } from "react-icons/tb";
import Select from "react-select";
import headerOne from "../assets/img/header_one.png";
import headerTwo from "../assets/img/header_two.png";
import headerThree from "../assets/img/header_three.png";
import "../assets/css/trial.css";
import { API_BASE_URL } from '../config';
import { motion, AnimatePresence } from "framer-motion";

const IMAGES = [headerOne, headerTwo, headerThree];

const validateEmailComercial = (emailComercial) => {
    if (!emailComercial) return false;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const emails = emailComercial
        .split(/[,;]/)
        .map(email => email.trim())
        .filter(email => email !== "");
    return emails.length > 0 && emails.every(email => emailRegex.test(email));
};

const formatTelefoneContato = (value) => {
    const digits = value.replace(/\D/g, "").slice(0, 11);

    if (!digits) return "";
    if (digits.length <= 2) return `(${digits}`;
    if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;

    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
};

const normalizeTelefoneContato = (value) => {
    let digits = value.replace(/\D/g, "");

    if (!digits) return "";
    if (digits.length === 10 || digits.length === 11) {
        digits = `55${digits}`;
    }

    return digits;
};

const Trial = ({ encryptedData }) => {
    const [cnpjValid, setCnpjValid] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [navbarBg, setNavbarBg] = useState('bg-transparent');
    const [navbarColor, setNavbarColor] = useState('text-black');
    const [currentImage, setCurrentImage] = useState(0);
    const [fade, setFade] = useState(true);

    const totalGrupos = 2;
    const [grupoAtual, setGrupoAtual] = useState(1);
    const [passoAtual, setPassoAtual] = useState(1);

    const inputRefEmail = useRef(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isMessageOpen, setIsMessageOpen] = useState(false);
    const [message, setMessage] = useState("");

    const [areaAtuacaoMunicipal, setAreaAtuacaoMunicipal] = useState([]);
    const [areaAtuacaoEstadual, setAreaAtuacaoEstadual] = useState([]);
    const [areaAtuacaoFederal, setAreaAtuacaoFederal] = useState([]);
    const [areaAtuacaoSubTributaria, setAreaAtuacaoSubTributaria] = useState([]);
    const [allAreasAtuacao, setAllAreasAtuacao] = useState([]);

    const [formData, setFormData] = useState({
        dadosDaEmpresa: {
            nomeContato: "",
            telefoneContato: "",
            razaoSocial: "",
            cnpj: "",
            cnpjsAdicionais: "",
            emailComercial: "",
        },
        dadosDaAreaDeAtuacao: {
            areaAtuacaoF: [],
            areaAtuacaoE: [],
            areaAtuacaoM: [],
            estadosAcompanhados: []
        },
        informacoesExtras: {
            ncms: "",
            marcasAssociadasESegmentosDeAtuacao: "",
            palavrasChaveParaAcompanhamento: ""
        }
    });

    const navigate = useNavigate();

    const formatOptions = (data) => data.map((item) => ({
        label: item.nome,
        id: item.id,
        value: item.nome,
        ativo: item.ativo,
    }));

    const optionsM = formatOptions(areaAtuacaoMunicipal);
    const optionsE = formatOptions(areaAtuacaoEstadual);
    const optionsF = formatOptions(areaAtuacaoFederal);
    const optionsSubTributaria = formatOptions(areaAtuacaoSubTributaria);

    const getSelectedOptions = (options, stateArray) =>
        options.filter(option => stateArray.some(item => item.nome === option.value));

    const selectedOptionsAreaDeAtuacaoF = getSelectedOptions(optionsF, formData.dadosDaAreaDeAtuacao.areaAtuacaoF);
    const selectedOptionsAreaDeAtuacaoE = getSelectedOptions(optionsE, formData.dadosDaAreaDeAtuacao.areaAtuacaoE);
    const selectedOptionsAreaDeAtuacaoM = getSelectedOptions(optionsM, formData.dadosDaAreaDeAtuacao.areaAtuacaoM);
    const selectedOptionsEstadosAcompanhados = getSelectedOptions(optionsSubTributaria, formData.dadosDaAreaDeAtuacao.estadosAcompanhados);

    const proximoGrupo = useCallback(() => {
        if (grupoAtual < totalGrupos) {
            setGrupoAtual(grupoAtual + 1);
            setPassoAtual(1);
        }
    }, [grupoAtual]);

    useEffect(() => {
        const fetchAllData = async () => {
            if (!encryptedData) {
                setCnpjValid(false);
                setIsLoading(false);
                return;
            }

            try {
                const cnpjReq = axios.post(`${API_BASE_URL}/validate-empresa`, { encryptedData });
                const mReq = axios.get(`${API_BASE_URL}/search-area-atuacao-municipal`);
                const eReq = axios.get(`${API_BASE_URL}/search-area-atuacao-estadual`);
                const fReq = axios.get(`${API_BASE_URL}/search-area-atuacao-federal`);
                const stReq = axios.get(`${API_BASE_URL}/search-area-atuacao-subtributaria`);

                const [cnpjRes, mRes, eRes, fRes, stRes] = await Promise.allSettled([cnpjReq, mReq, eReq, fReq, stReq]);

                if (cnpjRes.status === 'fulfilled') setCnpjValid(cnpjRes.value.data.exists);
                else setCnpjValid(false);

                if (mRes.status === 'fulfilled') setAreaAtuacaoMunicipal(mRes.value.data.areas_atuacao);
                if (eRes.status === 'fulfilled') setAreaAtuacaoEstadual(eRes.value.data.areas_atuacao);
                if (fRes.status === 'fulfilled') setAreaAtuacaoFederal(fRes.value.data.areas_atuacao);
                if (stRes.status === 'fulfilled') setAreaAtuacaoSubTributaria(stRes.value.data.areas_atuacao);

            } catch (error) {
                console.error("Erro ao carregar dados:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchAllData();
    }, [encryptedData]);

    useEffect(() => {
        setAllAreasAtuacao([...areaAtuacaoMunicipal, ...areaAtuacaoEstadual, ...areaAtuacaoFederal]);
    }, [areaAtuacaoMunicipal, areaAtuacaoEstadual, areaAtuacaoFederal]);

    useEffect(() => {
        const interval = setInterval(() => {
            setFade(false);
            setTimeout(() => {
                setCurrentImage((prev) => (prev + 1) % IMAGES.length);
                setFade(true);
            }, 250);
        }, 20000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const heroSection = document.getElementById('hero');
            if (heroSection) {
                const scrollPosition = window.scrollY;
                if (scrollPosition > heroSection.offsetHeight) {
                    setNavbarBg('bg-white shadow');
                    setNavbarColor('#676a6c');
                } else {
                    setNavbarBg('bg-transparent');
                    setNavbarColor('white');
                }
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        if (inputRefEmail.current) {
            inputRefEmail.current.style.height = "40px";
            inputRefEmail.current.style.height = `${inputRefEmail.current.scrollHeight}px`;
        }
    }, [formData.dadosDaEmpresa.emailComercial, passoAtual]);

    useEffect(() => {
        if (isModalOpen || isMessageOpen) {
            document.body.classList.add('modal-open');
        } else {
            document.body.classList.remove('modal-open');
        }
    }, [isModalOpen, isMessageOpen]);

    const handleSelectChange = (field, selectedOptions) => {
        setFormData(prev => ({
            ...prev,
            dadosDaAreaDeAtuacao: {
                ...prev.dadosDaAreaDeAtuacao,
                [field]: selectedOptions ? selectedOptions.map(opt => ({ id: opt.id, nome: opt.value, ativo: opt.ativo })) : []
            }
        }));
    };

    const handleScrollToSection = useCallback((id) => {
        const element = document.getElementById(id);
        if (element) element.scrollIntoView({ behavior: 'smooth' });
    }, []);

    const handleImageChange = useCallback((index) => {
        setFade(false);
        setTimeout(() => {
            setCurrentImage(index);
            setFade(true);
        }, 250);
    }, []);

    const handleChange = useCallback((e) => {
        const { name, value, dataset: { group } } = e.target;
        const formattedValue = name === "telefoneContato" ? formatTelefoneContato(value) : value;

        setFormData(prevData => ({
            ...prevData,
            [group]: { ...prevData[group], [name]: formattedValue }
        }));
    }, []);

    const handleStepClick = useCallback((e) => {
        const group = e.target.dataset.group;
        if (group) {
            const newGrupo = parseInt(group.split('grupo')[1]);
            if (newGrupo && newGrupo >= 1 && newGrupo <= totalGrupos) {
                setGrupoAtual(newGrupo);
                setPassoAtual(1);
            }
        }
    }, [totalGrupos]);

    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        setIsModalOpen(true);

        const selecionados = [
            ...formData.dadosDaAreaDeAtuacao.areaAtuacaoF,
            ...formData.dadosDaAreaDeAtuacao.areaAtuacaoE,
            ...formData.dadosDaAreaDeAtuacao.areaAtuacaoM
        ];

        if (selecionados.length > 0) {
            let ativos = [];
            let inativos = [];

            selecionados.forEach((id) => {
                const local = allAreasAtuacao.find(l => l.id === id.id);
                if (local) {
                    local.ativo ? ativos.push(local.nome) : inativos.push(local.nome);
                }
            });

            if (inativos.length > 0) {
                let mensagem = "Atenção! ⚠️\n\n";
                if (ativos.length === 0) {
                    mensagem += `Nenhum dos locais selecionados '${inativos.join(", ")}' está disponível para o trial.\n\n` +
                        "Todos os locais selecionados serão avaliados futuramente.";
                } else {
                    mensagem += `Dos locais de acompanhamento selecionados, apenas '${ativos.join(", ")}' estão disponíveis para o trial.\n\n` +
                        `Os demais '${inativos.join(", ")}' serão avaliados futuramente.`;
                }
                setMessage(mensagem);
                setIsMessageOpen(true);
            }
        }
    }, [formData, allAreasAtuacao]);

    const validateForm = () => {
        const { dadosDaEmpresa, dadosDaAreaDeAtuacao } = formData;

        if (!dadosDaEmpresa.razaoSocial.trim()) return "A razão social da empresa é obrigatória.";
        if (!dadosDaEmpresa.cnpj.trim()) return "O CNPJ principal da empresa é obrigatório.";
        if (!dadosDaEmpresa.emailComercial.trim()) return "O e-mail comercial da empresa é obrigatório.";
        if (!validateEmailComercial(dadosDaEmpresa.emailComercial)) return "Existem e-mails inválidos na lista de E-mails.";

        if (dadosDaAreaDeAtuacao.areaAtuacaoF.length === 0) return "Selecione pelo menos um local de acompanhamento federal.";
        if (dadosDaAreaDeAtuacao.areaAtuacaoE.length === 0) return "Selecione pelo menos um local de acompanhamento estadual.";
        if (dadosDaAreaDeAtuacao.areaAtuacaoM.length === 0) return "Selecione pelo menos um local de acompanhamento municipal.";

        return null;
    };

    const handleConfirm = useCallback(async () => {
        try {
            setIsModalOpen(false);
            const errorMessage = validateForm();

            if (errorMessage) {
                setMessage(errorMessage + " ❌");
                setIsMessageOpen(true);
                return;
            }

            const selecionados = [
                ...formData.dadosDaAreaDeAtuacao.areaAtuacaoF,
                ...formData.dadosDaAreaDeAtuacao.areaAtuacaoE,
                ...formData.dadosDaAreaDeAtuacao.areaAtuacaoM
            ];

            let ativosArray = [];
            let inativosArray = [];
            let estadosAtivosSelecionadosArray = [];

            selecionados.forEach((id) => {
                const local = Object.values(allAreasAtuacao).flatMap(arr => arr).find(l => l.id === id.id);
                if (local) {
                    local.ativo ? ativosArray.push(local.nome) : inativosArray.push(local.nome);
                }
            });

            const estadosSelecionados = [
                ...formData.dadosDaAreaDeAtuacao.areaAtuacaoE,
                ...formData.dadosDaAreaDeAtuacao.estadosAcompanhados
            ];

            if (estadosSelecionados.length > 0) {
                estadosSelecionados.forEach((id) => {
                    const estadoAtivo =
                        areaAtuacaoEstadual.find(e => e.id === id.id && e.ativo) ||
                        areaAtuacaoSubTributaria.find(e => e.id === id.id && e.ativo);

                    if (estadoAtivo) estadosAtivosSelecionadosArray.push(estadoAtivo.nome);
                });
            }

            // locaisAcompanhamentoAtivo: Junta todos os ativos + os estados ativos selecionados (removendo duplicatas com Set)
            const locaisCompletosAtivos = Array.from(new Set([...ativosArray, ...estadosAtivosSelecionadosArray]));
            const substituicaoTributariaArray = Array.from(new Set(estadosAtivosSelecionadosArray));

            const formatEmailComercial = (email) => email ? email.split(/[,;]/).map(e => e.trim()).filter(e => e !== "").join(";") : "";
            formData.dadosDaEmpresa.emailComercial = formatEmailComercial(formData.dadosDaEmpresa.emailComercial);
            const telefoneContato = normalizeTelefoneContato(formData.dadosDaEmpresa.telefoneContato);

            setIsLoading(true);

            await axios.post(`${API_BASE_URL}/save-empresa`, {
                encryptedData: encryptedData,
                nomeContato: formData.dadosDaEmpresa.nomeContato,
                telefoneContato: telefoneContato,
                cnpj: formData.dadosDaEmpresa.cnpj,
                razaoSocial: formData.dadosDaEmpresa.razaoSocial,
                emailsComerciais: formData.dadosDaEmpresa.emailComercial,
                locaisAcompanhamentoAtivo: locaisCompletosAtivos.join(","),
                substituicaoTributaria: substituicaoTributariaArray.join(","),

                flg_setup_brasil: 0,
                escopo: `<div>
                    <label>Locais de acompanhamento inativo:</label><br/><span>${inativosArray.join(",") || "Nenhum"}<span/><br/><br/>
                    <label>CNPJs Adicionais:</label><br/><span>${formData.dadosDaEmpresa.cnpjsAdicionais || "Nenhum"}<span/><br/><br/>
                    <label>NCMs:</label><br/><span>${formData.informacoesExtras.ncms || "Nenhum"}<span/><br/><br/>
                    <label>Marcas Associadas e Segmentos de Atuação:</label><br/><span>${formData.informacoesExtras.marcasAssociadasESegmentosDeAtuacao || "Nenhuma"}<span/><br/><br/>
                    <label>Palavras-chave:</label><br/><span>${formData.informacoesExtras.palavrasChaveParaAcompanhamento || "Nenhuma"}<span/>
                </div>`,
            }, {
                headers: { "Content-Type": "application/json" },
                withCredentials: true
            });

            setIsLoading(false);
            setMessage("Sua solicitação foi enviada com sucesso! Em breve entraremos em contato. ✅");
            setIsMessageOpen(true);

            setTimeout(() => {
                navigate("/");
            }, 3000);
        } catch (error) {
            setIsLoading(false);
            setMessage("Ocorreu um erro! Entre em contato com o nosso atendimento pelo e-mail tax.update@taxupdate.com.br. ❌");
            setIsMessageOpen(true);
        }
    }, [formData, allAreasAtuacao]);

    if (isLoading) return <div className="loader-wrapper"><div className="loader"></div></div>;
    if (cnpjValid === false) return <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh', backgroundColor: 'white' }}><div className="text-center text-dark display-4">Este formulário está bloqueado para edição</div></div>;

    // GRUPO 1: DADOS DA EMPRESA
    const renderDadosDaEmpresa = () => (
        <AnimatePresence>
            <motion.div className="formulario-grupo w-100" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}>
                <h3 className="grupo-titulo mb-4">Dados da Empresa</h3>
                <div className="campos-grupo">
                    <div className="row pl-3">
                        <div className="col-md-6 passo-item mb-3" style={{ maxWidth: '359px' }}>
                            <label className="font-weight-bold">Nome do contato</label>
                            <input
                                type="text"
                                name="nomeContato"
                                data-group="dadosDaEmpresa"
                                value={formData.dadosDaEmpresa.nomeContato}
                                onChange={handleChange}
                                className="input form-control"
                                placeholder="Nome do responsável para contato."
                            />
                        </div>

                        <div className="col-md-6 passo-item mb-3" style={{ maxWidth: '359px' }}>
                            <label className="font-weight-bold">Telefone para contato</label>
                            <input
                                type="text"
                                name="telefoneContato"
                                data-group="dadosDaEmpresa"
                                value={formData.dadosDaEmpresa.telefoneContato}
                                onChange={handleChange}
                                className="input form-control"
                                placeholder="Ex: (99) 99999-9999"
                            />
                        </div>
                    </div>

                    <div className="passo-item mb-3">
                        <label className="font-weight-bold">Razão Social</label>
                        <input
                            type="text"
                            name="razaoSocial"
                            data-group="dadosDaEmpresa"
                            value={formData.dadosDaEmpresa.razaoSocial}
                            onChange={handleChange}
                            className="input form-control"
                            placeholder=""
                            required
                        />
                    </div>

                    <div className="passo-item mb-3">
                        <label className="font-weight-bold">CNPJ Principal</label>
                        <input
                            type="number"
                            name="cnpj"
                            data-group="dadosDaEmpresa"
                            value={formData.dadosDaEmpresa.cnpj}
                            onChange={handleChange}
                            className="input form-control"
                            placeholder="CNPJ somente números."
                            required
                        />
                    </div>

                    <div className="passo-item mb-3">
                        <label className="font-weight-bold">CNPJs Adicionais</label>
                        <textarea
                            name="cnpjsAdicionais"
                            data-group="dadosDaEmpresa"
                            value={formData.dadosDaEmpresa.cnpjsAdicionais}
                            onChange={handleChange}
                            className="text_area form-control"
                            placeholder="Por favor, informe os CNPJs relacionados à empresa, separados por vírgula."
                        />
                    </div>

                    <div className="passo-item mb-3">
                        <label className="font-weight-bold">E-mails para recebimento</label>
                        <textarea
                            ref={inputRefEmail}
                            name="emailComercial"
                            data-group="dadosDaEmpresa"
                            value={formData.dadosDaEmpresa.emailComercial}
                            onChange={handleChange}
                            className="text_area form-control"
                            placeholder="Por favor, informar todos os e-mails que deverão receber os relatórios diários separados por vírgula."
                            required
                        />
                    </div>
                </div>
            </motion.div>
        </AnimatePresence>
    );

    // GRUPO 2: REGRAS DE NEGÓCIO
    const renderRegrasDeNegocio = () => (
        <AnimatePresence>
            <motion.div className="formulario-grupo w-100" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}>
                <h3 className="grupo-titulo mb-4">Regras de Negócio</h3>

                <div className="passo-item mb-3">
                    <label className="font-weight-bold">Locais de Acompanhamento FEDERAL</label>
                    <Select
                        value={selectedOptionsAreaDeAtuacaoF}
                        isMulti
                        options={optionsF}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        onChange={(v) => handleSelectChange('areaAtuacaoF', v)}
                        placeholder="Selecione. "
                        noOptionsMessage={() => "Sem resultados"}
                    />
                </div>

                <div className="row mb-3">
                    <div className="col-md-6 mb-3 mb-md-0 ml-3" style={{ maxWidth: '364px' }}>
                        <label className="font-weight-bold">Locais de Acompanhamento ESTADUAL</label>
                        <Select
                            value={selectedOptionsAreaDeAtuacaoE}
                            isMulti
                            options={optionsE}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            onChange={(v) => handleSelectChange('areaAtuacaoE', v)}
                            placeholder="Selecione."
                            noOptionsMessage={() => "Sem resultados"}
                        />
                    </div>

                    <div className="col-md-6" style={{ maxWidth: '400px' }}>
                        <label className="font-weight-bold">Locais apenas para fins de Substituição Tributária (ST)</label>
                        <Select
                            value={selectedOptionsEstadosAcompanhados}
                            isMulti
                            options={optionsSubTributaria}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            onChange={(v) => handleSelectChange('estadosAcompanhados', v)}
                            placeholder="Selecione."
                            noOptionsMessage={() => "Sem resultados"}
                        />
                    </div>
                </div>

                <div className="passo-item mb-4">
                    <label className="font-weight-bold">Locais de Acompanhamento MUNICIPAL</label>
                    <Select
                        value={selectedOptionsAreaDeAtuacaoM}
                        isMulti
                        options={optionsM}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        onChange={(v) => handleSelectChange('areaAtuacaoM', v)}
                        placeholder="Selecione."
                        noOptionsMessage={() => "Sem resultados"}
                    />
                </div>

                {/* Box de Dados Complementares */}
                <div className="dados-complementares p-4 border rounded bg-light mt-4">
                    <h4 className="mb-4 fw-bold">Dados Complementares</h4>

                    <div className="mb-3">
                        <label className="font-weight-bold">NCMs para acompanhamento</label>
                        <textarea
                            name="ncms"
                            data-group="informacoesExtras"
                            value={formData.informacoesExtras.ncms}
                            onChange={handleChange}
                            className="text_area form-control"
                            placeholder="Favor listar todos os NCMs que deseja acompanhar, apenas números, separados por vírgula."
                        />
                        <small className="text-muted d-block mt-1">Por favor, indique a lista completa ou envie por e-mail em Excel.</small>
                    </div>

                    <div className="mb-3">
                        <label className="font-weight-bold">Marcas Associadas e Segmentos de Atuação</label>
                        <textarea
                            name="marcasAssociadasESegmentosDeAtuacao"
                            data-group="informacoesExtras"
                            rows={3}
                            value={formData.informacoesExtras.marcasAssociadasESegmentosDeAtuacao}
                            onChange={handleChange}
                            className="text_area form-control"
                            placeholder="Informe as marcas ou produtos vinculados à empresa que deseja destacar ou acompanhar, assim como os segmentos de atividade principal, os temas relevantes e outros segmentos em que a empresa atua."
                        />
                        <small className="text-muted d-block mt-1">Marcas Associadas: informe as marcas ou produtos vinculados à empresa que deseja destacar ou acompanhar.<br />Segmentos de Atuação: descreva a atividade principal, os temas relevantes e outros segmentos em que a empresa atua.</small>
                    </div>

                    <div className="mb-3">
                        <label className="font-weight-bold">Palavras-chave relevantes para o acompanhamento. Ex.: ICMS, Reforma Tributária, etc</label>
                        <textarea
                            name="palavrasChaveParaAcompanhamento"
                            data-group="informacoesExtras"
                            value={formData.informacoesExtras.palavrasChaveParaAcompanhamento}
                            onChange={handleChange}
                            className="text_area form-control"
                            placeholder="Insira termos separados por vírgula para monitoramento."
                            required
                        />
                        <small className="text-muted d-block mt-1">Dica: quanto mais específicas forem as palavras-chave, melhor será o monitoramento legislativo.</small>
                    </div>
                </div>
            </motion.div>
        </AnimatePresence>
    );

    return (
        <div style={{ backgroundColor: 'white' }}>
            <nav className={`navbar navbar-expand-lg py-2 ${navbarBg} fixed-top w-100 z-3`}>
                <div className="container">
                    <a className="px-2 py-1 text-white bg-custom" href="https://cliente.taxupdate.com.br/" target="_blank" rel="noreferrer">
                        ÁREA DE CLIENTE
                    </a>

                    <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
                        <ul className="navbar-nav ms-auto">
                            {['HOME', 'PASSOS'].map((item, index) => (
                                <li key={index} className="nav-item">
                                    <a className="nav-link active fw-bold" style={{ color: navbarColor, cursor: 'pointer' }} onClick={() => handleScrollToSection(index === 0 ? 'topo' : 'steps')}>
                                        {item}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </nav>

            <div className={`text-start py-5 bg-cover bg-center position-relative transition-opacity ${fade ? 'opacity-100' : 'opacity-0'}`} style={{ backgroundImage: `url(${IMAGES[currentImage]})`, minHeight: '500px' }} id="topo">
                <button
                    className="carousel-control-prev position-absolute custom-carousel start-0 translate-middle-y z-3"
                    onClick={() => handleImageChange((currentImage - 1 + IMAGES.length) % IMAGES.length)}
                >
                    ❮
                </button>

                <button
                    className="carousel-control-next position-absolute custom-carousel end-0 translate-middle-y z-3 fs-2 fw-bold"
                    onClick={() => handleImageChange((currentImage + 1) % IMAGES.length)}
                >
                    ❯
                </button>

                <div className="container pt-5 mt-4">
                    {currentImage === 0 && <><h1 className="display-4 text-white fs-custom-title" id="hero">SEM EXCESSOS, SEM FALTA DE<br />INFORMAÇÃO.</h1><p className="lead text-white fs-custom-text">AJUSTE AQUI O SEU ESCOPO PARA UM MONITORAMENTO PRECISO.</p></>}
                    {currentImage === 1 && <><h1 className="display-4 text-white fs-custom-title" id="hero">CUSTOMIZE SEU MONITORAMENTO<br />EM MINUTOS.</h1><p className="lead text-white fs-custom-text">ESCOLHA REGIÃO, TEMAS E PALAVRAS-CHAVE E RECEBA APENAS O QUE INTERESSA.</p></>}
                    {currentImage === 2 && <><h1 className="display-4 text-white fs-custom-title" id="hero">PERSONALIZE SEU MONITORAMENTO<br />TRIBUTÁRIO.</h1><p className="lead text-white fs-custom-text">E RECEBA APENAS NORMAS QUE REALMENTE IMPORTAM PARA O SEU NEGÓCIO.</p></>}

                    <div className="carousel-indicators position-absolute start-50 translate-middle-x d-flex gap-2 custom-bottom">
                        {IMAGES.map((_, index) => <span key={index} onClick={() => handleImageChange(index)} className={`rounded-circle ${currentImage === index ? 'bg-white' : 'bg-secondary'}`} style={{ width: '10px', height: '10px', cursor: 'pointer' }}></span>)}
                    </div>
                </div>
            </div>

            <AnimatePresence>
                <motion.div className="container pt-5 mt-5" id="steps" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}>
                    <div className="row text-center justify-content-center">
                        {['Dados da Empresa', 'Regras de Negócio'].map((passo, index) => {
                            const isActive = grupoAtual === (index + 1);
                            return (
                                <div key={index} className="col-md-5">
                                    <h4 style={{ color: isActive ? '#007bff' : '#6C737F', fontSize: '1.2rem', fontWeight: isActive ? 'bold' : 'normal', textDecoration: isActive ? 'underline' : 'none', transition: 'all 0.3s ease', cursor: 'pointer' }} data-group={`grupo${index + 1}`} onClick={handleStepClick}>
                                        {passo}
                                    </h4>

                                    <p style={{ color: '#aeaeae' }}>Passo {index + 1} de {totalGrupos}</p>
                                </div>
                            );
                        })}
                    </div>
                </motion.div>
            </AnimatePresence>

            <AnimatePresence>
                <motion.div className="container pt-3 mt-3 formulario" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}>
                    <motion.form onSubmit={handleSubmit} className="mx-auto" style={{ maxWidth: "800px" }}>
                        <div className="d-flex justify-content-center align-items-center w-100">
                            {grupoAtual === 1 ? renderDadosDaEmpresa() : renderRegrasDeNegocio()}
                        </div>
                    </motion.form>

                    <div className="d-flex w-100 justify-content-between align-items-center mb-4 mt-4" style={{ maxWidth: "800px", margin: "0 auto" }}>
                        {grupoAtual === 1 && <p></p>}
                        {grupoAtual > 1 && <button type="button" className="btn btn-secondary rounded-pill px-4" onClick={() => setGrupoAtual(grupoAtual - 1)}>❮ Voltar</button>}
                        {grupoAtual < totalGrupos ? (
                            <button type="button" className="btn btn-success rounded-pill px-4" onClick={proximoGrupo}>Avançar ❯</button>
                        ) : (
                            <button type="submit" className="btn btn-primary rounded-pill px-4" onClick={handleSubmit}>Concluir ✔</button>
                        )}
                    </div>
                </motion.div>
            </AnimatePresence>

            <AnimatePresence>
                {isModalOpen && (
                    <motion.div className="modal-overlay" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}>
                        <motion.div className="modal-content" style={{ maxHeight: '90vh', overflowY: 'auto' }} initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.8, opacity: 0 }}>
                            <h2 className="mb-4">Confirme os dados</h2>

                            <div className="modal-body text-start">
                                <div className="modal-section mb-4">
                                    <h3 className="border-bottom pb-2">Dados da Empresa</h3>
                                    <label className="font-weight-bold mt-2">NOME DO CONTATO</label>
                                    <input className='input form-control mb-2' type="text" name='nomeContato' value={formData.dadosDaEmpresa.nomeContato} data-group="dadosDaEmpresa" onChange={handleChange} />
                                    <label className="font-weight-bold mt-2">TELEFONE PARA CONTATO</label>
                                    <input className='input form-control mb-2' type="text" name='telefoneContato' value={formData.dadosDaEmpresa.telefoneContato} data-group="dadosDaEmpresa" onChange={handleChange} />
                                    <label className="font-weight-bold mt-2">RAZÃO SOCIAL</label>
                                    <input className='input form-control mb-2' type="text" name='razaoSocial' value={formData.dadosDaEmpresa.razaoSocial} data-group="dadosDaEmpresa" onChange={handleChange} required />
                                    <label className="font-weight-bold mt-2">CNPJ PRINCIPAL</label>
                                    <input className='input form-control mb-2' type="number" name='cnpj' value={formData.dadosDaEmpresa.cnpj} data-group="dadosDaEmpresa" onChange={handleChange} required />
                                    <label className="font-weight-bold mt-2">CNPJs ADICIONAIS</label>
                                    <input className='input form-control mb-2' type="text" name='cnpjsAdicionais' value={formData.dadosDaEmpresa.cnpjsAdicionais} data-group="dadosDaEmpresa" onChange={handleChange} />
                                    <label className="font-weight-bold mt-2">E-MAILS PARA RECEBIMENTO</label>
                                    <textarea className="text_area form-control mb-2" name="emailComercial" value={formData.dadosDaEmpresa.emailComercial} data-group="dadosDaEmpresa" onChange={handleChange} required />
                                </div>

                                <div className="modal-section mb-4">
                                    <h3 className="border-bottom pb-2">Regras de Negócio</h3>
                                    <label className="font-weight-bold mt-2">Acompanhamento FEDERAL</label>
                                    <Select value={selectedOptionsAreaDeAtuacaoF} isMulti name="areaAtuacaoF" options={optionsF} className="mb-3" onChange={(v) => handleSelectChange('areaAtuacaoF', v)} />

                                    <label className="font-weight-bold">Acompanhamento ESTADUAL</label>
                                    <Select value={selectedOptionsAreaDeAtuacaoE} isMulti name="areaAtuacaoE" options={optionsE} className="mb-3" onChange={(v) => handleSelectChange('areaAtuacaoE', v)} />

                                    <label className="font-weight-bold">Locais apenas para fins de Substituição Tributária (ST)</label>
                                    <Select value={selectedOptionsEstadosAcompanhados} isMulti name="estadosAcompanhados" options={optionsSubTributaria} className="mb-3" onChange={(v) => handleSelectChange('estadosAcompanhados', v)} />

                                    <label className="font-weight-bold">Acompanhamento MUNICIPAL</label>
                                    <Select value={selectedOptionsAreaDeAtuacaoM} isMulti name="areaAtuacaoM" options={optionsM} className="mb-3" onChange={(v) => handleSelectChange('areaAtuacaoM', v)} />
                                </div>

                                <div className="modal-section mb-4">
                                    <h3 className="border-bottom pb-2">Dados Complementares</h3>
                                    <label className="font-weight-bold mt-2">NCMs para acompanhamento (por favor, indique a lista completa ou envie por e-mail em Excel)</label>
                                    <textarea className="text_area form-control mb-2" name="ncms" value={formData.informacoesExtras.ncms} data-group="informacoesExtras" onChange={handleChange} />

                                    <label className="font-weight-bold mt-2">Marcas Associadas e Segmentos de Atuação</label>
                                    <textarea className="text_area form-control mb-2" name="marcasAssociadasESegmentosDeAtuacao" value={formData.informacoesExtras.marcasAssociadasESegmentosDeAtuacao} data-group="informacoesExtras" onChange={handleChange} />

                                    <label className="font-weight-bold mt-2">Palavras-chave relevantes para o acompanhamento. Ex.: ICMS, Reforma Tributária, etc</label>
                                    <textarea className="text_area form-control mb-2" name="palavrasChaveParaAcompanhamento" value={formData.informacoesExtras.palavrasChaveParaAcompanhamento} data-group="informacoesExtras" onChange={handleChange} required />
                                </div>

                            </div>
                            <div className="modal-actions d-flex justify-content-end gap-2 mt-3 pt-3 border-top">
                                <button className="btn btn-secondary px-4" onClick={() => setIsModalOpen(false)}>Cancelar</button>
                                <button className="btn btn-primary px-4" onClick={handleConfirm}>Confirmar</button>
                            </div>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>

            <AnimatePresence>
                {isMessageOpen && (
                    <motion.div className="modal-overlay" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}>
                        <motion.div className="modal-content-message" initial={{ y: 50, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: -50, opacity: 0 }} transition={{ duration: 0.3 }}>
                            <h2 style={{ whiteSpace: "pre-wrap" }}>{message}</h2>
                            <button onClick={() => setIsMessageOpen(false)} className="btn btn-primary mt-3">OK</button>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>

            <div className="pt-5 mt-5">
                <footer style={{ backgroundColor: "#ECF5F3" }} className="py-4">
                    <div className="container">
                        <div className="row justify-content-center text-center">
                            <div className="col-12">
                                <div className="mb-4 d-flex justify-content-center" style={{ gap: "5px" }}>
                                    <a href="https://www.linkedin.com/company/taxupdate/" target="_blank" rel="noreferrer">
                                        <button
                                            type="button"
                                            className="btn btn-secondary rounded-circle d-flex align-items-center justify-content-center"
                                            style={{ width: "40px", height: "40px" }}
                                        >
                                            <FaLinkedin />
                                        </button>
                                    </a>

                                    <a href="https://taxupdate.com.br/" target="_blank" rel="noreferrer">
                                        <button
                                            type="button"
                                            className="btn btn-secondary rounded-circle d-flex align-items-center justify-content-center"
                                            style={{ width: "40px", height: "40px", fontSize: "30px" }}
                                        >
                                            <TbWorld />
                                        </button>
                                    </a>
                                </div>

                                <p style={{ color: "#333", fontWeight: "bold" }}>
                                    © {new Date().getFullYear()} TaxUpdate
                                </p>

                                <p className="mb-0" style={{ color: "#333" }}>
                                    Todos os direitos reservados
                                </p>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        </div>
    );
};

export default Trial;